module.exports = __webpack_public_path__ + "static/media/laugh.7a7d5d8b.svg";